module.exports = [
  {
    title: 'Ремонт дизельной топливной аппаратуры',
    info:
      'Мы обслуживаем в Донецке ТНВД, насос-форсунки, форсунки, системы Common Rail уже 15 лет. В нашем распоряжении оборудование от официальных производителей систем Bosch, Hartridge, Delphi, Denso. Это позволяет делать высокоточные проверки и настройки.',
    items: [
      {
        title: 'Ремонт ТНВД и форсунок',
        info:
          'Ремонт ТНВД и форсунок начинается с диагностики на стенде, осмотра под микроскопом степени износа. На стенде проверяются форсунки для оценки объема распыляемого топлива, проводится замер фактических параметров. Проводится сравнение с эталонными параметрами.В Донецке диагностируем , делаем регулировку и ремонт ТНВД и форсунок:',
        list: [
          'одноплунжерных насосов типа VE с механическими и электронными регуляторами производства BOSCH, ZEXEL, DENSO',
          'ТНВД производства DELPHI (LUCAS) часто применяемых на легковых автомобилях, строительной и специализированной технике',
          'рядных ТНВД  А, М, MW, P-типа с механическими и электронными регуляторами, Н-типа, производства BOSCH, ZEXEL, DENSO',
          'ТНВД отечественной техники КамАЗ, ЯМЗ-236,ЯМЗ-238, ЯМЗ-240, МТЗ, СуперМАЗ ЕВРО-2, IKARUS',
          'форсунок BOSCH,ZEXEL,DENSO однопружинных, двухступенчатых, форкамерных, непосредственного впрыска, а также форсунок отечественного производства'
        ]
      },
      {
        title: 'Ремонт насос-форсунок',
        info:
          'Насос-форсунка объединяет в себе и одноплунжерный насос и форсунку. За счет того, что за смазку трущихся деталей отвечает топливо, это становится одной из главных проблем выхода из строя насос-форсунки. Выполняем проверку, ремонт, замену насос-форсунок:',
        list: [
          'насос-форсунок легковых автомобилей VW, Skoda',
          'насос-форсунок,PLD секций (насосных секций высокого давления) автомобилей МВ, VOLVO, SCANIA, DAF, IVECO',
          'насос-форсунок, американского производства DETROIT DIESEL, CAT, Cummins'
        ]
      },
      {
        title: 'Ремонт системы Common Rail',
        info:
          'Можно считать что Common Rail это вершина эволюции топливной аппаратуры дизельных двигателей. В отличии от ТНВД конструкция упрощена,  топливо закачивается в одному рейку . С другой стороны за систему подачи топлива отвечают электронно управляемые форсунки. Так сама рейка оснащена большим количеством датчиков отвечающих за давление в рейке, систем аварийного сброса давления. Ремонт таких систем требует спец оборудования, а также должной квалификации.В Донецке выполняем диагностику,ремонт систем Common Rail, форсунок:',
        list: [
          'Delphi на оборудовании фирмы HARTRIDGE дополнительно оснащенном дилерским программным обеспечением DELPHI которое позволяет при успешном прохождении теста присваивать форсунке индивидуальный код, который при монтаже прописывается в блок управления двигателя с привязкой к номеру цилиндра на который устанавливается форсунка.',
          'BOSCH широко применяющихся как на легковых так и на грузовых автомобилях и спецтехнике Европейского, Азиатского,  Японского производства.  Ремонт производится с соблюдение технологии ремонта и регулировочных параметров фирмы BOSCH',
          'DENSO устанавливаемых на автомобилях TOYOTA, NISSAN, FORD, CITROEN, PEUGEOT, MAZDA,SUBARU, OPEL, ISUZU, а также сельскохозяйственной и специализированной технике JOHN DEERE, JCB, HITACHI, KOMATSU'
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/data/topl.js